<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create Account" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-banking-account-form [account]="account" *ngIf="account"></app-banking-account-form>
        </form>
      </div>
    </section>
  </div>
</div>


